import { getClient } from '../core/global-config.js';
import { createAndWaitTask } from '../core/index.js';

export interface YouchuanDiffusionParams {
  /**
   * 生成图像的文本描述，必填，长度必须在1-8192个字符之间
   */
  text: string;
  /**
   * 回调URL，必须以http://或https://开头
   */
  callback?: string;
}

export interface YouchuanDiffusionResource {
  type: string;
  url: string;
  size?: number;
  jobId?: string;
  [key: string]: any;
}

/**
 * youchuan_diffusion
 *
 * 通过悠船扩散模型API创建图像生成任务。
 *
 * API Documentation: https://tob.youchuan.cn/openapi/apis/%E5%9B%BE%E7%89%87%E7%94%9F%E6%88%90/api_diffusion
 *
 * @example
 * ```typescript
 * import { initSeacloud, youchuanDiffusion } from 'seacloud-sdk';
 *
 * initSeacloud('your-api-key');
 *
 * const result = await youchuanDiffusion({
 *   text: 'A beautiful sunset over mountains'
 * });
 *
 * console.log(result); // 返回生成的资源列表
 * ```
 *
 * @param params 请求参数，详见 YouchuanDiffusionParams 接口定义
 * @returns 生成的资源列表
 */
export async function youchuanDiffusion(
  params: YouchuanDiffusionParams,
): Promise<YouchuanDiffusionResource[]> {
  const client = await getClient();

  const pollingOptions = {
    intervalMs: 3000,
    maxAttempts: 60,
  };

  const result = await createAndWaitTask(
    client,
    '/model/v1/generation',
    {
      model: 'youchuan_diffusion',
      input: [{ params }],
    },
    pollingOptions,
  );

  const resources: YouchuanDiffusionResource[] = [];

  if (result.output) {
    for (const item of result.output) {
      if (item.content) {
        for (const resource of item.content) {
          resources.push({
            type: resource.type || 'unknown',
            url: resource.url || '',
            size: resource.size,
            jobId: resource.jobId,
            ...resource,
          });
        }
      }
    }
  }

  return resources;
}
